import { SchemeTypes } from 'config';
import { LanguagesEnum } from '../../../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  period_control: {
    [LanguagesEnum.English]: 'Vat Return Period',
    [LanguagesEnum.Greek]: 'Vat Return Period',
  },
  year_control: {
    [LanguagesEnum.English]: 'Year',
    [LanguagesEnum.Greek]: 'Year',
  },
  consuption_control: {
    [LanguagesEnum.English]: 'MS Consuption',
    [LanguagesEnum.Greek]: 'MS Consuption',
  },
  amount_control: {
    [LanguagesEnum.English]: 'Vat Amount Of Correction (€)',
    [LanguagesEnum.Greek]: 'Vat Amount Of Correction (€)',
  },
  cents_control: {
    [LanguagesEnum.English]: 'Cents',
    [LanguagesEnum.Greek]: 'Cents',
  },
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  add: {
    [LanguagesEnum.English]: 'Add Correction',
    [LanguagesEnum.Greek]: 'Add Correction',
  },
  amount_error: {
    [LanguagesEnum.English]: 'You can put an amount up to €-',
    [LanguagesEnum.Greek]: 'You can put an amount up to €-',
  },
  negative_cents_error: {
    [LanguagesEnum.Greek]: 'Valid: 0-99',
    [LanguagesEnum.English]: 'Valid: 0-99',
  },
  invalid_cents_error: {
    [LanguagesEnum.Greek]: '1-2 digits',
    [LanguagesEnum.English]: '1-2 digits',
  },
  invalid_amount_cents_error: {
    [LanguagesEnum.Greek]: 'Valid: 0-99',
    [LanguagesEnum.English]: 'Valid: 0-99',
  },
};

export default CONFIGURATION;

// --EU scheme ,Goods Services
// --Non Eu   , Services
// --Import Scheme  , Goods

export const getSupplyTypes = (schemeType: number) => {
  switch (schemeType) {
    case SchemeTypes.EU:
      return [
        {
          id: '1',
          label: 'GOODS',
        },
        {
          id: '2',
          label: 'SERVICES',
        },
      ];
    case SchemeTypes.NON_EU:
      return [
        {
          id: '2',
          label: 'SERVICES',
        },
      ];
    case SchemeTypes.IOSS:
      return [
        {
          id: '1',
          label: 'GOODS',
        },
      ];
    default:
      return [];
  }
};
